import { render, staticRenderFns } from "./LoadingBaseClassList.vue?vue&type=template&id=68b7b77e&lang=pug"
import script from "./LoadingBaseClassList.vue?vue&type=script&lang=js"
export * from "./LoadingBaseClassList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports